module.exports = __webpack_public_path__ + "img/mask-img3.5c8e9ece.png";